import { ReportsFilter } from '../types/ReportsFilter';

export const noSearchParamsProvided = (searchParams: ReportsFilter): boolean =>
  !searchParams.query && !searchParams.endDate;
